(function(angular){
	'use strict';
	
	angular
		.module('sharedDataVisualizationModule', [
			'BaseConfig', 
			'highChartsModule'
		])
		.value('globalConfig', globalConfig);

})(window.angular);